// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let React = require("react");
let Scalars = require("../../../scalars/Scalars.bs.js");
let DialogV5 = require("../../common/Components/DialogV5.bs.js");
let ButtonsV5 = require("../../common/Components/ButtonsV5.bs.js");
let ViewStack = require("../../../reason/common/ViewStack.bs.js");
let ReactRender = require("../../../reason/utils/ReactRender.bs.js");
let Form__Helpers = require("../../../reason/common/Form/Form__Helpers.bs.js");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let Form__Checkbox = require("../../common/Components/Form__Checkbox.bs.js");
let Form__TextArea = require("../../common/Components/Form__TextArea.bs.js");
let Form__TextInput = require("../../common/Components/Form__TextInput.bs.js");
let JsxRuntime = require("react/jsx-runtime");
let InlineWarning__Jsx3 = require("../../../uikit/reason/atoms/InlineWarning/InlineWarning__Jsx3.bs.js");
let RescriptRelay_Mutation = require("rescript-relay/src/RescriptRelay_Mutation.bs.js");
let MarkPropertyAsSoldDialogMutation_graphql = require("../../../__generated__/MarkPropertyAsSoldDialogMutation_graphql.bs.js");

let convertVariables = MarkPropertyAsSoldDialogMutation_graphql.Internal.convertVariables;

let convertResponse = MarkPropertyAsSoldDialogMutation_graphql.Internal.convertResponse;

let convertWrapRawResponse = MarkPropertyAsSoldDialogMutation_graphql.Internal.convertWrapRawResponse;

let commitMutation = RescriptRelay_Mutation.commitMutation(convertVariables, MarkPropertyAsSoldDialogMutation_graphql.node, convertResponse, convertWrapRawResponse);

let use = RescriptRelay_Mutation.useMutation(convertVariables, MarkPropertyAsSoldDialogMutation_graphql.node, convertResponse, convertWrapRawResponse);

let MarkPropertyAsSoldMutation = {
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapRawResponse,
  commitMutation: commitMutation,
  use: use
};

function MarkPropertyAsSoldDialog(props) {
  let close = props.close;
  let propertyId = props.propertyId;
  let match = use();
  let mutate = match[0];
  let match$1 = React.useState(() => "");
  let setComment = match$1[1];
  let comment = match$1[0];
  let match$2 = React.useState(() => {});
  let setSoldPrice = match$2[1];
  let soldPrice = match$2[0];
  let match$3 = React.useState(() => false);
  let setHideSoldPrice = match$3[1];
  let hideSoldPrice = match$3[0];
  let match$4 = React.useState(() => "Idle");
  let setSubmissionStatus = match$4[1];
  let submissionStatus = match$4[0];
  let resetForm = () => {
    setSubmissionStatus(param => "Idle");
    setComment(param => "");
    setSoldPrice(param => {});
    setHideSoldPrice(param => false);
  };
  let __x = submissionStatus === "SubmissionError";
  return JsxRuntime.jsx(DialogV5.make, {
    title: "Mark property as sold",
    isOpen: props.isOpen,
    ariaLabel: "Mark property as sold",
    onDismiss: () => close(),
    size: "Large",
    children: JsxRuntime.jsx("form", {
      children: JsxRuntime.jsxs(ViewStack.make, {
        children: [
          JsxRuntime.jsx("div", {
            children: "Once this property is marked as sold, it will no longer be active for new matches on TAN. The new TAN status and your comments will show to TAN members on existing matches."
          }),
          JsxRuntime.jsx(Form__TextInput.make, {
            labelText: "Sold price",
            optionalText: "optional",
            onChange: evt => {
              let value = Form__Helpers.intFromFormattedPrice(evt);
              setSoldPrice(param => value);
            },
            prepend: "$",
            value: Form__Helpers.intOptToFormattedPrice(soldPrice)
          }),
          JsxRuntime.jsx(Form__Checkbox.make, {
            onChange: param => setHideSoldPrice(prev => !prev),
            checked: hideSoldPrice,
            label: "Keep sold price private (only visible to you)",
            mobileStyles: true
          }),
          JsxRuntime.jsx(Form__TextArea.make, {
            labelText: "Comments",
            optionalText: "optional",
            onChange: evt => setComment(evt.target.value),
            value: comment
          }),
          ReactRender.ifTrue(JsxRuntime.jsx(InlineWarning__Jsx3.make, {
            children: "There was a problem updating the property. Please try again."
          }), __x),
          JsxRuntime.jsxs(ViewStack.make, {
            mt: "lg",
            space: "sm",
            justifyContent: "flexEnd",
            flexDirection: "row",
            children: [
              JsxRuntime.jsx(ButtonsV5.SecondaryButton.make, {
                onClick: param => close(),
                disabled: submissionStatus === "Loading",
                size: "medium",
                _type: "button",
                children: "Cancel"
              }),
              JsxRuntime.jsx(ButtonsV5.PrimaryButton.make, {
                disabled: submissionStatus === "Loading",
                children: "Mark as sold"
              })
            ]
          })
        ]
      }),
      onSubmit: event => {
        event.preventDefault();
        setSubmissionStatus(param => "Loading");
        mutate({
          input: {
            comments: Form__Helpers.opt_of_string(comment),
            hideSoldPrice: hideSoldPrice,
            id: propertyId,
            soldPrice: Stdlib_Option.map(soldPrice, Scalars.PriceInput.fromInt)
          }
        }, undefined, undefined, undefined, (param, param$1) => {
          let markForSalePropertySold = param.markForSalePropertySold;
          if (markForSalePropertySold === undefined) {
            return setSubmissionStatus(param => "SubmissionError");
          }
          if (markForSalePropertySold.__typename !== "ForSalePropertyMarkedSold") {
            return setSubmissionStatus(param => "SubmissionError");
          }
          close();
          resetForm();
        }, param => setSubmissionStatus(param => "SubmissionError"), undefined);
      }
    })
  });
}

let make = MarkPropertyAsSoldDialog;

exports.MarkPropertyAsSoldMutation = MarkPropertyAsSoldMutation;
exports.make = make;
/* commitMutation Not a pure module */
